import { render, staticRenderFns } from "./CommercantFiltres.vue?vue&type=template&id=12c3c698&"
import script from "./CommercantFiltres.vue?vue&type=script&lang=js&"
export * from "./CommercantFiltres.vue?vue&type=script&lang=js&"
import style0 from "./CommercantFiltres.vue?vue&type=style&index=0&id=12c3c698&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports